// frontend/src/routes/ProtectedRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { logger } from "../utils/logger.js"; // ← Add this import
const ProtectedRoute = ({ children, requiresPremium = false }) => {
  const { token, loading, user } = useContext(AuthContext);

  logger.log("=== ProtectedRoute Debug Info ===");
  //logger.log("Current path:", location.pathname);
  //logger.log("ProtectedRoute — token:", token);
  //logger.log("ProtectedRoute — user:", user);
  logger.log("ProtectedRoute — loading:", loading);
  logger.log("User onboarding_completed:", user?.onboarding_completed);
  logger.log("=====================================");

  if (loading) {
    logger.log("ProtectedRoute: Showing loading state");
    return <p>Checking authentication...</p>;
  }

  if (!token) {
    logger.log("ProtectedRoute: No token, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // If token exists but user is still null, it means token verification is in progress
  if (token && !user) {
    logger.log(
      "ProtectedRoute: Token exists but user is null, showing verification message"
    );
    return <p>Verifying credentials...</p>;
  }

  // Check if user exists and onboarding is not completed
  if (user && !user.onboarding_completed) {
    logger.log(
      "ProtectedRoute: User needs onboarding, redirecting to /onboarding"
    );
    return <Navigate to="/onboarding" replace />;
  }

  // Soft Paywall check
  if (requiresPremium && user && user.plan_name === 'free') {
    logger.log("ProtectedRoute: Route requires premium, but user is on free tier. Redirecting.");
    return <Navigate to="/pricing?from_dashboard_upsell=true" replace />;
  }

  // If both token and user exist and onboarding is completed, allow access
  logger.log("ProtectedRoute: All checks passed, rendering children");
  return children;
};

export default ProtectedRoute;
